(function () {

  var mousepadHeaderStats = [
    {
      type: "tag_group_bar",
      key: "surface_type",
      title: "Glide",
      include: ["Control", "Balanced", "Speed"]
    },
    {
      type: "tag_group_bar",
      key: "surface_material",
      title: "Surface",
      include: ["Cloth", "Glass", "Cordura"],
      remainder_label: "Others"
    },
    {
      type: "tag_group_bar",
      key: "firmness",
      title: "Firmness"
    }
  ];

  window.EG_COLLECTION_HEADER_STATS = {
    default: [],

    handles: {
      "gaming-mousepads": mousepadHeaderStats,
      "test-collection": mousepadHeaderStats
    }
  };

})();